const namespace = "profile";

export const area_of_interest_select = `${namespace}_area_of_interest_select`;
export const skill_want_select = `${namespace}_skill_want_select`;
